import { get, post } from '../axios'

// 网关设置电器 黑名单
export const loadSetGatewayBlackList = params => post(`/web/gatewayElectricBlack/setGatewayBlackList`, params);

// 黑名单列表
export const loadGatewayElectricBlack = gatewayId => get(`/web/gatewayElectricBlack/listByGatewayId/${gatewayId}`);

// 黑名单列表移除
export const loadPhysicalDelete = params => post(`/web/gatewayElectricBlack/physicalDelete`, params);
